
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^([cijx]|xy)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
